import React, { useEffect, useState } from 'react'
import Item from './item'

interface IInstallmentDetailLoan {
    id: number
    is_paid: boolean
    jalali_due_date: string
    amount: number
    is_delayed: boolean
}

interface ILoansProps {
    data: IInstallmentDetailLoan[]
    setIsOpen: React.Dispatch<React.SetStateAction<boolean>>
    setLoanAmount: React.Dispatch<React.SetStateAction<number | undefined>>
    setSelectedInstallment: React.Dispatch<
        React.SetStateAction<number | undefined>
    >
}

export default function Loans({
    data,
    setIsOpen,
    setLoanAmount,
    setSelectedInstallment,
}: ILoansProps) {
    const [lastPaidIndex, setLastPaidIndex] = useState(-1)

    // محاسبه آخرین قسط پرداخت شده
    useEffect(() => {
        const lastPaid = data.reduce((acc, curr, index) => {
            return curr.is_paid ? index : acc
        }, -1)
        setLastPaidIndex(lastPaid)
    }, [data])

    return (
        <div className="bg-main-bg p-3 text-sm">
            <p className="text-center mb-2">جزییات اقساط ({data.length} قسط)</p>
            <div className="flex flex-col">
                {data.map((item, originalIndex) => {
                    const isNextUnpaid = originalIndex === lastPaidIndex + 1
                    const shouldShowPayButton = !item.is_paid && isNextUnpaid

                    return (
                        <Item
                            key={item.id}
                            index={originalIndex}
                            jalaliDate={item.jalali_due_date}
                            amount={item.amount}
                            isDelayed={item.is_delayed}
                            setIsOpen={setIsOpen}
                            setLoanAmount={setLoanAmount}
                            isPayed={item.is_paid}
                            setSelectedInstallment={setSelectedInstallment}
                            id={item.id}
                            shouldShowPayButton={shouldShowPayButton}
                        />
                    )
                })}
            </div>
        </div>
    )
}
